import { render } from "./mapBasicSetting.vue?vue&type=template&id=367511a4&scoped=true"
import script from "./mapBasicSetting.vue?vue&type=script&lang=js"
export * from "./mapBasicSetting.vue?vue&type=script&lang=js"

import "./mapBasicSetting.vue?vue&type=style&index=0&id=367511a4&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-367511a4"]])

export default __exports__